import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../base/hooks";
import { ICookieRegistrationProps } from "./ICookieRegistrationProps";

export const CookieRegistrationProperties = [
    { id: Property.CookieName, name: 'Cookie Name', type: PropertyType.String },
    { id: Property.ValidAfterMins, name: 'Valid After (Mins)', type: PropertyType.Number },
]

export const useCookieRegistration = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<ICookieRegistrationProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const cookieName = bindings.getValue<string>(Property.CookieName) || '';
        const validAfterMins = bindings.getValue<number>(Property.ValidAfterMins) || 30;

        setProperties({ cookieName, validAfterMins })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}

